// SAJAFO — personalisatie op de productpagina
// Plaatsen als Assets/product-personalization.js

(function () {
  function initPersonalization(root) {
    var toggle = root.querySelector('[data-se-personalize-toggle]');
    var fields = root.querySelector('[data-se-personalize-fields]');
    var tabText = root.querySelector('[data-se-tab="text"]');
    var tabImage = root.querySelector('[data-se-tab="image"]');
    var panelText = root.querySelector('[data-se-panel="text"]');
    var panelImage = root.querySelector('[data-se-panel="image"]');
    var textInput = root.querySelector('[data-se-engrave-text]');
    var fileInput = root.querySelector('[data-se-engrave-file]');
    var errorEl = root.querySelector('[data-se-personalize-error]');
    var maxChars = parseInt(root.getAttribute('data-se-max-chars') || '16', 10);
    var isRequired = root.hasAttribute('data-se-required');

    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    function showTab(which) {
      var isText = which === 'text';
      panelText.style.display = isText ? 'block' : 'none';
      panelImage.style.display = isText ? 'none' : 'block';
      tabText.classList.toggle('active', isText);
      tabImage.classList.toggle('active', !isText);

      // Alleen de actieve invoer wordt meegestuurd naar het winkelwagentje,
      // en alleen als personaliseren daadwerkelijk is aangevinkt (of altijd, als verplicht).
      var personalizeOn = isRequired || !toggle || toggle.checked;
      if (textInput) textInput.disabled = !(isText && personalizeOn);
      if (fileInput) fileInput.disabled = !(!isText && personalizeOn);
      hideError();
    }

    if (toggle && fields) {
      toggle.addEventListener('change', function () {
        fields.hidden = !toggle.checked;
        showTab(tabText && tabText.classList.contains('active') ? 'text' : 'image');
      });
    }

    if (tabText && tabImage) {
      tabText.addEventListener('click', function () { showTab('text'); });
      tabImage.addEventListener('click', function () { showTab('image'); });
      showTab('text');
    }

    if (textInput) {
      textInput.setAttribute('maxlength', maxChars);
      textInput.addEventListener('input', hideError);
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var label = root.querySelector('[data-se-file-label]');
        if (label && fileInput.files[0]) {
          label.textContent = fileInput.files[0].name;
        }
        hideError();
      });
    }

    // Verplichte personalisatie: blokkeer het toevoegen aan winkelwagen zolang er
    // geen tekst of afbeelding is opgegeven. Bij een optioneel product (met
    // checkbox, bv. de beschermkapjes) geldt dezelfde blokkade zodra de klant
    // "Ik wil dit product personaliseren" heeft aangevinkt - staat de checkbox
    // uit, dan is er niets verplicht. Luistert in de capture-fase op document,
    // zodat dit vóór Dawn's eigen (bubble-fase) submit-handler op het formulier
    // draait.
    if (isRequired || toggle) {
      var form = document.querySelector('product-form form');
      if (form) {
        document.addEventListener(
          'submit',
          function (event) {
            if (event.target !== form) return;

            var personalizeRequested = isRequired || (toggle && toggle.checked);
            if (!personalizeRequested) return;

            var isTextActive = tabText && tabText.classList.contains('active');
            var hasText = textInput && textInput.value.trim() !== '';
            var hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
            var valid = isTextActive ? hasText : hasFile;

            if (!valid) {
              event.preventDefault();
              event.stopPropagation();
              if (errorEl) errorEl.hidden = false;
              if (isTextActive && textInput) {
                textInput.focus();
              } else if (fileInput) {
                fileInput.focus();
              }
            }
          },
          true
        );
      }
    }
  }

  // Twee onafhankelijke, optionele kanten (voorkant/achterkant) in één groep:
  // hier is geen van beide op zichzelf verplicht, maar er moet minimaal één
  // kant daadwerkelijk ingevuld zijn (aangevinkt + tekst of afbeelding) voordat
  // het product besteld kan worden.
  function blockHasContent(block) {
    var toggle = block.querySelector('[data-se-personalize-toggle]');
    if (toggle && !toggle.checked) return false;
    var tabText = block.querySelector('[data-se-tab="text"]');
    var textInput = block.querySelector('[data-se-engrave-text]');
    var fileInput = block.querySelector('[data-se-engrave-file]');
    var isTextActive = tabText && tabText.classList.contains('active');
    if (isTextActive) return !!(textInput && textInput.value.trim() !== '');
    return !!(fileInput && fileInput.files && fileInput.files.length > 0);
  }

  function initPersonalizationGroup(root) {
    var blocks = Array.prototype.slice.call(root.querySelectorAll('[data-se-personalization]'));
    var errorEl = root.querySelector('[data-se-personalize-error]');
    var form = document.querySelector('product-form form');
    if (!form || blocks.length === 0) return;

    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    blocks.forEach(function (block) {
      var textInput = block.querySelector('[data-se-engrave-text]');
      var fileInput = block.querySelector('[data-se-engrave-file]');
      var toggle = block.querySelector('[data-se-personalize-toggle]');
      if (textInput) textInput.addEventListener('input', hideError);
      if (fileInput) fileInput.addEventListener('change', hideError);
      if (toggle) toggle.addEventListener('change', hideError);
    });

    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form) return;
        var anyValid = blocks.some(blockHasContent);
        if (!anyValid) {
          event.preventDefault();
          event.stopPropagation();
          if (errorEl) errorEl.hidden = false;
        }
      },
      true
    );
  }

  document.querySelectorAll('[data-se-personalization]').forEach(initPersonalization);
  document.querySelectorAll('[data-se-personalization-group]').forEach(initPersonalizationGroup);
})();
